import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { LogoMark } from "../components/Logo";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <header className="sticky top-0 z-30 bg-[#0A0A0A]/95 backdrop-blur border-b border-[#1A1A1A]">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/login" className="flex items-center gap-2 text-[#A3A3A3] hover:text-white" data-testid="back-link">
            <ArrowLeft size={20} weight="bold" /> Indietro
          </Link>
          <div className="flex items-center gap-2">
            <LogoMark size={28} />
            <span className="font-heading font-black text-xl uppercase tracking-tight">
              ETA<span className="text-[#FFD600]">Build</span>
            </span>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-8" data-testid="terms-page">
        <div className="mb-6">
          <div className="text-xs uppercase tracking-[0.2em] text-[#A3A3A3] font-bold">Documento legale</div>
          <h1 className="font-heading text-4xl font-black uppercase tracking-tighter leading-none mt-1">
            Termini & Condizioni
          </h1>
          <p className="text-xs text-[#A3A3A3] mt-2">Ultimo aggiornamento: febbraio 2026</p>
        </div>

        <div className="space-y-5 text-sm text-[#D4D4D4] leading-relaxed">
          <section>
            <h2 className="font-heading text-lg font-black uppercase text-[#FFD600] mb-2">1. Oggetto del contratto</h2>
            <p>
              ETA Build è un servizio SaaS destinato a imprese edili, elettriche, idrauliche e
              professionisti del settore, che fornisce strumenti digitali per la gestione di
              preventivi, computi metrici, listino DEI, anagrafica dipendenti, timbrature ore,
              gestione attestati e visualizzazioni AI di lavorazioni di cantiere.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-black uppercase text-[#FFD600] mb-2">2. Abbonamento e pagamenti</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Il servizio è offerto in modalità abbonamento mensile su 2 piani: <b>Standard 8€/mese</b> e <b>Premium 15€/mese</b> (IVA inclusa).</li>
              <li><b>Periodo di prova</b>: 30 giorni gratuiti dalla registrazione; nessun pagamento è richiesto durante la prova.</li>
              <li>Il pagamento è gestito da <b>Stripe Payments Europe Ltd.</b> (Dublino, Irlanda), certificata PCI-DSS Level 1.</li>
              <li>Il rinnovo è <b>automatico mensile</b> e può essere disdetto in qualsiasi momento dal Portale Clienti Stripe accessibile dalla sezione "Abbonamento" dell'app.</li>
              <li>In caso di mancato pagamento il servizio passa in stato "past_due" per 7 giorni, dopodiché viene sospeso fino a regolarizzazione.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-lg font-black uppercase text-[#FFD600] mb-2">3. Promotion codes & sconti</h2>
            <p>
              Durante il checkout è disponibile un campo <b>"Add promotion code"</b> dove l'utente
              può inserire codici sconto pubblici (es. <code className="text-[#FFD600]">PROMO30</code>,{" "}
              <code className="text-[#FFD600]">PARTNER50</code>) o codici personali ricevuti tramite
              il programma referral (formato <code className="text-[#FFD600]">AMICO-XXX</code>).
              I codici sono soggetti a termini specifici (durata, limite utilizzi, percentuale)
              definiti dal Titolare e visibili nello stesso campo Stripe Checkout.
              I codici personali referral sono <b>monouso</b> e non trasferibili.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-black uppercase text-[#FFD600] mb-2">4. Diritto di recesso</h2>
            <p>
              Trattandosi di servizio digitale erogato in modalità SaaS, l'utente può recedere
              <b> in qualsiasi momento</b> annullando l'abbonamento dal Portale Clienti. La
              cancellazione ha effetto al termine del periodo già pagato (no rimborso pro-rata
              ai sensi dell'art. 59 lett. m del Codice del Consumo per i servizi digitali iniziati
              con consenso espresso).
            </p>
            <p className="mt-2">
              L'eliminazione definitiva dell'account e di tutti i dati è disponibile da{" "}
              <b>Profilo → Elimina Account</b> ed è conforme al GDPR art. 17.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-black uppercase text-[#FFD600] mb-2">5. Limitazioni di responsabilità</h2>
            <p>
              <b>I calcoli, le quantità e le immagini generate dall'intelligenza artificiale sono
              simulazioni indicative</b>. ETA Build NON è uno strumento di progettazione
              certificata. In particolare:
            </p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li>Gli <b>overlay IA di ponteggi</b> non sostituiscono il <b>Pi.M.U.S.</b> (Piano di Montaggio Uso Smontaggio) richiesto dal D.Lgs. 81/2008.</li>
              <li>I <b>computi metrici automatici</b> non sostituiscono il computo metrico estimativo redatto da tecnico abilitato.</li>
              <li>L'utente è l'unico responsabile della verifica strutturale, della sicurezza in cantiere e dell'eventuale convalida da parte di architetto, ingegnere o geometra iscritto al rispettivo Ordine professionale.</li>
              <li>ETA Build non risponde di danni diretti o indiretti derivanti dall'utilizzo improprio degli output AI in violazione delle normative tecniche di settore.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-lg font-black uppercase text-[#FFD600] mb-2">6. Uso del servizio</h2>
            <p>L'utente si impegna a:</p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li>Utilizzare il servizio in conformità alle leggi italiane ed europee.</li>
              <li>Non caricare immagini o dati che violino la privacy di terzi senza loro consenso.</li>
              <li>Informare i propri dipendenti del trattamento dei loro dati (anagrafica, attestati, timbrature) ai sensi GDPR.</li>
              <li>Non condividere le credenziali di accesso con terzi.</li>
              <li>Non tentare di accedere a dati di altri utenti né effettuare reverse-engineering del servizio.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-lg font-black uppercase text-[#FFD600] mb-2">7. Proprietà intellettuale</h2>
            <p>
              Il software ETA Build, il logo, il marchio e tutti i contenuti tecnici sono di
              proprietà esclusiva del Titolare. I dati operativi caricati dall'utente
              (preventivi, foto, anagrafiche dipendenti) restano di sua esclusiva proprietà.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-black uppercase text-[#FFD600] mb-2">8. Modifiche & Foro competente</h2>
            <p>
              Eventuali modifiche ai presenti Termini saranno comunicate via email registrata
              con preavviso di 15 giorni. Per ogni controversia è competente in via esclusiva
              il foro del domicilio del Titolare. Si applica la legge italiana.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-black uppercase text-[#FFD600] mb-2">9. Contatti</h2>
            <p>
              Per qualsiasi domanda su questi Termini o sul servizio:{" "}
              <a href="mailto:lucaroc2@gmail.com" className="text-[#FFD600]">lucaroc2@gmail.com</a>
            </p>
            <p className="mt-2 text-xs text-[#A3A3A3]">
              Vedi anche la <Link to="/privacy" className="text-[#FFD600] underline">Privacy Policy</Link> per il trattamento dei dati personali.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
